import { createContext, useState } from 'react'

import { Modal } from 'antd'
import { useSelector } from 'react-redux'
import { isFunction, isObject } from 'lodash'

import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import { selectUser } from '../../../reducers/UserReducer'
import { onError, onSuccess } from '../../../utils/apiHelper'
import { Actions } from '../../../utils/events'
import MaccsInternshipForm from './MaccsInternshipForm'
import { MaccsInternshipValidators } from '../../../utils/entities/maccsInternship'
import { createMaccsInternship, updateMaccsInternship } from '../../../utils/api/maccsInternship'

export const MaccsInternshipModalContext = createContext()

export const Modes = Object.freeze({
  CREATE: 1,
  UPDATE: 2,
  EDIT_SECTOR: 3
})

const DEFAULT_DATA = {
  object: null,
  callback: null,
  mode: null
}

const MaccsInternshipModal = ({ children, sectors = [], keysToValidate = [] }) => {
  const t = useSelector(selectTranslate)
  const user = useSelector(selectUser)

  const [data, setData] = useState(DEFAULT_DATA)

  const handleSubmit = updatedInternship => {
    const config = {
      [Modes.CREATE]: { action: Actions.CREATE, promise: createMaccsInternship, parameters: [user, updatedInternship.toRequestBody()] },
      [Modes.UPDATE]: { action: Actions.UPDATE, promise: updateMaccsInternship, parameters: [user, updatedInternship, updatedInternship.toRequestBody()] }
    }

    const handlerConfig = updatedInternship.id > 0 ? config[Modes.UPDATE] : config[Modes.CREATE]

    handlerConfig.promise(...handlerConfig.parameters).then(json => {
      if (json?.data && isFunction(data.callback)) {
        data.callback(json.data)
      }

      setData(DEFAULT_DATA)
      onSuccess(t(`maccs_internship_form.${handlerConfig.action.toLowerCase()}.success`))
    }).catch(error => {
      console.error(error)
      onError(t(`maccs_internship_form.${handlerConfig.action.toLowerCase()}.error`))
    })
  }

  return (
    <>
      <MaccsInternshipModalContext.Provider value={{ setData }}>
        {children}
      </MaccsInternshipModalContext.Provider>
      <Modal
        width={800}
        className='form-modal'
        title={t('internship_form.title')}
        visible={isObject(data.object)}
        onCancel={() => setData(DEFAULT_DATA)}
        footer={null}
      >
        <MaccsInternshipForm
          data={data.object}
          sectors={sectors}
          validators={MaccsInternshipValidators}
          onSubmit={handleSubmit}
          onCancel={() => setData(DEFAULT_DATA)}
        />
      </Modal>
    </>
  )
}

export default MaccsInternshipModal
